export enum PricingMode {
  KeepPreviousPrice = 'KeepPreviousPrice',
  Regular = 'Regular',
  Custom = 'Custom',
  Discount = 'Discount',
}
